export default __webpack_public_path__ + "static/media/_dkg_pankreas_rgb.e31563e6.svg";